import { gql } from "@apollo/client";

export const NAVBAR_QUERY = gql`
  query Navbar {
    me {
      id
      email
      companyName
      isAdmin
      datasetExists
      activeIncidentCount
      activeAccountMaintenanceItemCount
      dataBlessingTimesV2 {
        platform
        type
        timestamp
      }
      dataProcessedAt
      nextProcessedAt
      processingPerDay
      timezone
      accountMaintenanceItems(
        activeOnly: true
        type: "ConnectionIssue"
        maxUrgency: 100
      ) {
        id
      }
    }
    users {
      id
      isAdmin
      email
      companyName
    }
    currentServerVersion
  }
`;

export const DATA_REFRESH_TIME_QUERY = gql`
  query DataRefreshTime {
    me {
      activeAccountMaintenanceItemCount
      dataBlessingTimesV2 {
        platform
        type
        timestamp
      }
      dataProcessedAt
      nextProcessedAt
      processingPerDay
      timezone
    }
  }
`;
